
// const backendDomin = "https://fasalshop.com/Api"
const backendDomin = "https://admin1.fasalshop.com/Api"

const SummaryApi = {
    sendOtp: {
        url: `${backendDomin}/login`,
        method: "POST"
    },
    verifyOtp: {
        url: `${backendDomin}/verify_otp`,
        method: "POST"
    },
    signUP: {
        url: `${backendDomin}/signup`,
        method: "post"
    },

    signIn: {
        url: `${backendDomin}/signin`,
        method: "post"
    },

    register: {
        url: `${backendDomin}/new_user_registration`,
        method: "POST"
    },

    updateProfile: {
        url: `${backendDomin}/update_profile`,
        method: "POST"
    },
    viewProfile: {
        url: `${backendDomin}/view_profile`,
        method: "GET"
    },
    current_user: {
        url: `${backendDomin}/user-details`,
        method: "get"
    },
    logout_user: {
        url: `${backendDomin}/userLogout`,
        method: 'get'
    },
    allUser: {
        url: `${backendDomin}/all-user`,
        method: 'get'
    },
    updateUser: {
        url: `${backendDomin}/update-user`,
        method: "post"
    },
    uploadProduct: {
        url: `${backendDomin}/upload-product`,
        method: 'post'
    },
    allProduct: {
        url: `${backendDomin}/get_all_product_list`,
        method: 'GET'
    },
    updateProduct: {
        url: `${backendDomin}/update-product`,
        method: 'post'
    },
    categoryProduct: {
        url: `${backendDomin}/vendor_available_category_list`,
        method: 'POST'
    },
    getBrand: {
        url: `${backendDomin}/brand`,
        method: 'GET'
    },
    categoryWiseProduct: {
        url: `${backendDomin}/category-product`,
        method: 'post'
    },
    productDetails: {
        url: `${backendDomin}/product_by_id`,
        method: 'post'
    },
    categoryById: {
        url: `${backendDomin}/category_by_id`,
        method: 'POST'
    },
    subcategoryById: {
        url: `${backendDomin}/subcategory_by_id`,
        method: 'POST'
    },
    addToCartProduct: {
        url: `${backendDomin}/add_to_cart`,
        method: 'post'
    },
    addToCartProductCount: {
        url: `${backendDomin}/countAddToCartProduct`,
        method: 'get'
    },
    addToCartProductView: {
        url: `${backendDomin}/view_cart`,
        method: 'GET'
    },
    updateCartProduct: {
        url: `${backendDomin}/update_cart`,
        method: 'post'
    },
    deleteCartProduct: {
        url: `${backendDomin}/delete_cart`,
        method: 'post'
    },
    search_product: {
        url: `${backendDomin}/search_api`,
        method: 'POST'
    },
    search_subcategory: {
        url: `${backendDomin}/search_subcategory`,
        method: "POST"
    },
    search_item_by_type_name: {
        url: `${backendDomin}/search_item_by_type_name`,
        method: "POST"
    },
    search_category_by_name: {
        url: `${backendDomin}/search_category_by_name`,
        method: "POST"
    },
    search_subcategory_by_name: {
        url: `${backendDomin}/search_subcategory_by_name`,
        method: "POST"
    },
    search_brand_by_name: {
        url: `${backendDomin}/search_brand_by_name`,
        method: "POST"
    },

    filterProduct: {
        url: `${backendDomin}/filter-product`,
        method: 'post'
    },
    view_cart: {
        url: `${backendDomin}/view_cart`,
        method: "GET"
    },
    add_to_cart: {
        url: `${backendDomin}/add_to_cart`,
        method: "POST"
    },
    update_cart: {
        url: `${backendDomin}/update_cart`,
        method: "POST"
    },
    delete_cart: {
        url: `${backendDomin}/delete_cart`,
        method: "POST"
    },
    addShippingAddress: {
        url: `${backendDomin}/add_shipping_address`,
        method: "POST"
    },
    updateShippingAddress: {
        url: `${backendDomin}/update_app_users_address`,
        method: "POST"
    },
    deleteShippingAddress: {
        url: `${backendDomin}/delete_shipping_address`,
        method: "POST"
    },
    setDefaultShippingAddress: {
        url: `${backendDomin}/set_default_shipping_address`,
        method: "POST"
    },
    getAllAddress: {
        url: `${backendDomin}/get_all_address`,
        method: "GET"
    },
    placeOrder: {
        url: `${backendDomin}/place_order`,
        method: "POST"
    },
    getCustomerOrders: {
        url: `${backendDomin}/get_all_order_by_custumer_id`,
        method: "POST"
    },
    getCrop: {
        url: `${backendDomin}/crop`,
        method: "GET"
    },
    pagination: {
        url: `${backendDomin}/pagination_by_page_no_limit`,
        method: "POST"
    },
    getCategory: {
        url: `${backendDomin}/category`,
        method: "GET"
    },
    getStoreList: {
        url: `${backendDomin}/get_all_store_list`,
        method: "GET"
    },
    productByCategory: {
        url: `${backendDomin}/product_by_category_id`,
        method: "POST"
    },
    productBySubCategory: {
        url: `${backendDomin}/product_by_category_sub_category_id`,
        method: "POST"
    },
    productByBrand: {
        url: `${backendDomin}/product_by_brand_id`,
        method: "POST"
    },
    translate: {
        url: `https://translation.googleapis.com/language/translate/v2`,
        method: "POST"
    },
    getPestDiseaseDeficiency: {
        url: `${backendDomin}/get_pest_disease_deficiency`,
        method: "POST"
    }
}

export default SummaryApi